<template>
  <div class="wrap">
    <div class="wrap-top">

      <div class="top-main">
        <div class="main-item" style="background-color: #4095E5">
          <p class="top">计划参加培训总数</p>
          <p class="bottom">{{form.need_training_count}} <span>次</span></p>
        </div>
        <div class="main-item" style="background-color: #E99D42">
          <p class="top">实际参加培训总数</p>
          <p class="bottom">{{form.participated_training_count}} <span>次</span></p>
        </div>
        <div class="main-item" style="background-color: #81B337">
          <p class="top">计划参加考试总数</p>
          <p class="bottom">{{form.need_exam_count}} <span>次</span></p>
        </div>
        <div class="main-item" style="background-color: #BFBF3D" >
          <p class="top">实际参加考试总数</p>
          <p class="bottom">{{form.participated_exam_count}} <span>次</span></p>
        </div>
        <div class="main-item" style="background-color: #BFBF3D" >
          <p class="top">一次性合格占比</p>
          <p class="bottom">{{form.first_exam_pass_percent}} <span>%</span></p>
        </div>
        <div class="main-item" style="background-color: #4095E5">
          <p class="top">考试合格总数</p>
          <p class="bottom">{{form.user_exam_pass_count}} <span>次</span></p>
        </div>
        <div class="main-item" style="background-color: #E99D42">
          <p class="top">考试不合格总数</p>
          <p class="bottom">{{form.participated_exam_count - form.user_exam_pass_count}} <span>次</span></p>
        </div>
        <div class="main-item" style="background-color: #81B337">
          <p class="top">最近一次培训时间</p>
          <p class="bottom" style="display: inline-block; width: 100%"> <span style="display: inline-block; width: 100%">{{form.last_training_time}}</span></p>
        </div>
        <div class="main-item" style="background-color: #BFBF3D" >
          <p class="top">最近一次考试时间</p>
          <p class="bottom" style="display: inline-block; width: 100%"><span style="display: inline-block; width: 100%">{{form.last_exam_time}}</span></p>
        </div>
        <div class="main-item" style="background-color: #BFBF3D" >
          <p class="top">最高考试分数</p>
          <p class="bottom">{{form.best_exam_score}} <span>分</span></p>
        </div>
      </div>
    </div>
    <div class="wrap-bottom">
      <div class="search-block">
        <div style="display: inline-block;width: 38%;">
          <p><span style="color: #4095E5;font-weight: bold">{{$route.query.user_name}}</span> / {{form.organization}}</p>
        </div>
        <el-input placeholder="请输入内容" clearable v-model="keywords" class="search-input"></el-input>
        <el-date-picker v-model="searchDate" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        <el-button style="background-color: #4787F0;color:#fff;margin-left: 14px;" @click="getData">搜索</el-button>
        <el-button style="background-color: #377F7F;color:#fff;" @click="handleExport">导出结果</el-button>
      </div>
      <div>
        <el-table
            :data="tableData"
            style="width: 100%">
          <el-table-column type="index" label="#" width="50"></el-table-column>
          <el-table-column prop="training_title" label="考试项目" min-width="180"></el-table-column>
          <el-table-column prop="exam_time" label="参加考试时间" width="160"></el-table-column>
          <el-table-column prop="exam_scores" label="考试分数" width="100"></el-table-column>
          <el-table-column prop="exam_ranking" label="排名" width="100"></el-table-column>
          <el-table-column prop="exam_pass" label="是否合格" width="110"></el-table-column>
          <el-table-column prop="answer_times" label="答题次数" width="100"></el-table-column>
          <el-table-column prop="" label="操作" width="110">
            <template v-slot  ="{row}">
              <el-button icon="el-icon-view" @click="handleCheck(row)" type="text" size="small">答题情况</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="el_pagination_style">
          <div>
            <div class="deadline">统计数据截止时间：{{getCurrentTime()}}</div>
          </div>
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageParams.page"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pageParams.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageParams.total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getUserExamDetail, getUserTrainingDetail, usersStat} from "@/api/training";

export default {
  name: "examRecordStatistics",
  data() {
    return {
      keywords:'',
      currentPage: 1,
      searchDate: [],
      tableData: [],
      form:{
        need_training_count:0,
      },
      pageParams:{
        page:1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    setTimeout(()=>{
      this.getData()
      this.gerUsersStat()
    },100)

  },
  methods: {
    gerUsersStat(){ //人员统计信息
      usersStat({user_id: this.$route.query.user_id}).then(res=>{
        this.form = res.data.results[0]

      })
    },
    getData(){
      let params = {
        user_id: this.$route.query.user_id,
        start_day:this.searchDate ? this.searchDate[0] : '',
        end_day:this.searchDate ? this.searchDate[1] : '',
        keywords: this.keywords,
      }
      getUserExamDetail(params).then(res=>{
        this.tableData = res.data.results
        this.pageParams.total = res.data.count
      })
    },
    handleExport(){
      let params = {
        user_id: this.$route.query.user_id,
        start_day: this.searchDate ? this.searchDate[0] : '',
        end_day:  this.searchDate ?  this.searchDate[1] : '',
        keywords: this.keywords,
        export:'True'
      }
      getUserExamDetail(params).then(res => {
        this.downloadFile(res.data.file_url)
      })
    },
    downloadFile(url) {
      return new Promise((resolve, reject) => {
        const fileName = url.split('/').pop()
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.download = fileName
        // 这个延迟操作的目的是为了确保浏览器有足够的时间来处理下载操作
        // 这样可以避免在循环中快速触发多个下载操作，导致浏览器无法正确处理下载请求
        link.addEventListener('click', () => {
          setTimeout(() => {
            resolve()
          }, 1000)
        })
        link.click()
      }).finally(()=>{this.exporting = false})
    },
    handleCheck(row) {
      this.$router.push({path: '/cloudTraining/exam/answeringStatus',query:{log_id:row.log_id,exam_id:row.exam_id}})
    },
    getCurrentTime() {
      const now = new Date();
      const pad = n => String(n).padStart(2, '0');
      return `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
    },
    handleSizeChange(val){
      this.pageParams.size = val
      this.pageParams.page = this.page
      this.getData();
    },
    handleCurrentChange(val) { // 翻页
      this.pageParams.size = this.size
      this.pageParams.page = val
      this.getData()
    },
  }
}
</script>


<style scoped lang="scss">
.wrap {
  margin: 10px 20px;
  box-sizing: border-box;

  .wrap-top {
    display: flex;
    justify-content: space-between;
    .top-main {
      border-radius: 3px;
      background-color: #fff;
      width: 100%;
      display: flex;
      justify-content: space-around;
      padding: 20px;
      box-sizing: border-box;

      .main-item {
        width: 9%;
        height: 100px;
        border-radius: 3px;
        padding: 12px 8px 16px 12px;
        box-sizing: border-box;
        position: relative;
        p.top {
          color: #fff;
          font-size: px(16);
          font-weight: bold;
        }

        p.bottom {
          position: absolute;
          color: #fff;
          text-align: center;
          font-size: 28px;
          bottom: 12px;
          left: 50%;
          transform: translateX(-50%);
          width: 100%;

          span {
            width: 100%;
            font-size: 16px;
          }
        }
      }
    }
  }

  .wrap-bottom {
    .search-block {
      display: inline-block;
      width: 100%;
      padding: 20px;
      box-sizing: border-box;
      background-color: #fff;
      margin: 20px 0;

      .search-input {
        width: 300px;
        margin-right: 20px;

        ::v-deep input {
          width: 100%;
        }
      }
    }
  }
}

::v-deep .el-table thead tr th {
  background-color: #2BAEE9;
  color: #fff;
}
//分页
 .el_pagination_style{
   background-color: #fff;
   position: relative;
 }
::v-deep .el-pagination__sizes{
  width: 80px;
  vertical-align: top;
}
::v-deep .el-pagination__sizes .el-select{
  vertical-align: top;
}
::v-deep .el-pagination__sizes input{
  width: 80px;
  height: 1.8rem;
  border: 1px solid #999999;
}
::v-deep .el-pagination .el-input__suffix{
  right: 22px;
}
::v-deep .el-range-editor--small .el-range-input{
  font-size: 0.75rem!important;
}
::v-deep .el-pager li{
  padding: 0 20px;
  height: 1.8rem;
  line-height: 1.8rem;
}
.deadline{
  position: absolute;
  display: inline-block;
  width: 100%;
  color: #6C6C6C;
  box-sizing: border-box;
  //font-size: px(13);
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
}
</style>